module.exports = __webpack_public_path__ + "static/media/tinyworldmk_1.d6d79a06.jpg";